// extracted by mini-css-extract-plugin
export default {"root":"messageToast_root__G+48Q","content":"messageToast_content__Hgca8","title":"messageToast_title__Y8N3f","subtitle":"messageToast_subtitle__XBG+k"};